import { Action } from 'redux';
import {
  ISelectPolicyProvider,
  IGetPolicyTypesByProviderLoaded,
  ICreateProviderPolicyMappingLoaded,
  ICreateProviderPolicyMappingLoading,
  IDeleteProviderPolicyTypeMappingLoaded,
  ISelectPolicyType,
  IGetPolicySubTypeByPolicyTypeLoaded,
  ICreatePolicyTypeSubTypeMappingLoaded,
  IDeletePolicyTypeSubTypeMappingLoaded,
  IUpdatePolicyProviderLoading,
  IUpdatePolicyProviderLoaded,
  IGetUsersLoaded,
  ISelectUser,
  IGetAttachmentForPolicyLoaded,
  IGetRenewalForPolicyLoaded,
  IAdminDeleteUserByIdLoaded,
  IUpdateProviderPolicyMappingLoaded,
  ISelectPolicySubType,
  IUpdateSelectedPolicySubType,
  IAdminGetUserLoaded,
  IAdminUpdateUserLoaded,
  IAdminGetUserPolicies,
  IAdminGetUserInvitationsLoaded,
  IAdminGetUserSentInvitationsLoaded,
  IAdminGetUserPolicyScansLoaded,
  IAdminLoading,
} from './admin-actions';
import {
  ILoading,
  ILoaded,
  IFailed,
  IPolicyScansLoaded,
  IPolicyScanLoaded,
  IPolicyScanLocalUpdated,
  IAddPolicyModelOpen,
  IUserBundlesLoaded,
  IFeedbackLoaded,
  IFilteredPoliciesLoaded,
  IOperationGetAdviserConnectLoaded,
  IOperationGetSelectedAdviserConnectLoaded,
  IEmailNotificationLoaded,
  IOperationGetMarketScanFeedbacks,
  IPolicyScanPayloadLoaded,
  IOperationUpdateAdviserConnectPolicyScans,
  IOperationUpdateAdviserConnectStatus,
  IOperationGetAdviserConnectsForUserLoaded,
} from './operation-actions';
import {
  IUpdateSelectedPolicyLocal,
  INewSelectedPolicyLocal,
  IAdminUpdatePolicyLoaded,
  IUpdateSelectedPolicyRenewLocal,
} from './operation-policy-actions';
import {
  IGetUserByIdLoaded,
  IGetUserByIdLoading,
  IUpdateUserLoaded,
  ISetCurrentFamily,
  IGetUserByIdFailed,
  IUpdateUserLoading,
} from './user';
import {
  ICreatePolicyLoaded,
  IGetUserPoliciesLoading,
  IGetUserPoliciesLoaded,
  IDeletePolicyLoaded,
  IUpdatePolicyLoaded,
  IResetPolicyForm,
  ICreatePolicyLoading,
  ISelectPolicy,
  IGetPolicyScanByPolicyIdLoaded,
  ICreatePolicyScanLoaded,
  IGetPendingPolicyScanLoaded,
  ICreatePolicyFailed,
  IGetPolicyScanLoaded,
  IUpdatePolicyScanLoaded,
  ICreatePoliciesLoaded,
  IDeletePoliciesLoaded,
  ICreatePolicyBundleLoaded,
  IGetPolicyBundlesLoaded,
  IDeletePolicyBundleLoaded,
  IUpdatePolicyLoading,
  ICreatePolicyScanLoading,
  ICreatePolicyScanFailed,
  ICreatePolicyScanWithoutPolicyLoaded,
  IResetSubmitted,
  IDeletePolicyScanLoaded,
} from './policy';
import {
  IGetAllAdvisersLoaded,
  IGetAdviserConnectsLoaded,
  ICreateAdviserConnectLoaded,
  IAdviserSubmitting,
  ICalendlyEventCreated,
  IAdviserConnectInfoUpdated,
  ICalendarLoading,
  IAdviserInquiryLoaded,
  IAdviserLoading,
  IAdviserFailed,
  IUpdateAdviserConnectLoaded,
  IGetAdviserConnectLoaded,
} from './adviser-actions';

import {
  IGetInvitationsLoaded,
  IInvitationLoading,
  IProcessInvitationLoaded,
  IDeleteInvitationLoaded,
  ICreateInvitationLoaded,
  IShowCreateInvitationForm,
  IInvitationFailed,
  IClearInvitationErrors,
  IGetSharedInvitationsLoaded,
  IUpdateInvitationLoaded,
} from './invitation-actions';
import { IConfig, IAppState } from 'types';
import { getConfig } from '../../services';
import {
  IPaymentLoading,
  IVerifyWindcavePaymentLoaded,
  IVerifyWindcavePaymentFailed,
  IPaymentReset,
  IPaymentError,
  IPaymentSuccess,
} from './payment-actions';
import {
  ICreateCreditCardPolicyLoaded,
  ICreditCardResetForm,
  ICreditCardSubmitting,
  IDeleteCreditCardPolicyLoaded,
  IGetCreditCardPoliciesLoaded,
} from './credit-card-actions';
import {
  ICreateRenewalLoaded,
  ICreateRenewalLoading,
  ICreatePendingRenewal,
  IDeletePendingRenewalLoaded,
  IDeleteRenewalLoaded,
  IPolicyRenewalFailed,
  IPolicyRenewalSubmitting,
  ISelectPolicyRenewalLoaded,
  IUpdateRenewalLoaded,
  IUpdatePendingRenewalLoaded,
  IResetRenewalSubmit,
  IGetPendingRenewalsLoaded,
  IGetRenewalsLoaded,
} from './policy-renewal-actions';
import {
  IOperationPolicyRenewalDetailsloaded,
  IOperationUpdatePolicyRenewal,
} from './operation-policy-renewal-actions';
import {
  GetAllPolicyTypes,
  GetAllPolicyProvider,
  GetCreditCardBenefitsData,
  GetEmployers,
  GetWiki,
  GetPolicyScanReference,
  IGetCreditCardBenefitsDataLoaded,
  IGetAllPolicyProvidersLoaded,
  IGetAllPolicyTypesLoaded,
  IGetAllPolicySubTypesLoaded,
  IGetEmployersLoaded,
  IGetWikiLoaded,
  IGetPolicyScanReferenceLoaded,
  ICeatePolicyTypeLoaded,
  ICreatePolicySubTypeLoaded,
  GetFormDefinitionReference,
} from './referencedata-actions';
import {
  IDeletePolicyNotificationsLoaded,
  IGetNotificationsLoaded,
  INotificationsLoading,
  ISeenNotificationsLoaded,
  IToggleAppBanner,
  IUpdateNotificationLoaded,
} from './notification-actions';
import {
  IShowSessionExpiredModal,
  IToggleSidebar,
} from './layout-actions';

import {
  ISetPaymentStatus,
  ISetShowStripe,
  ISetStripeLoading,
} from './provident-stripe-payment-actions';

import { ISetNavBarTitle, ISetUpdateMarketScanPopup, ISetPolicyDetailsSection } from './navbar-actions';
import { IMarketScanResultLoaded, IUpdateMarketScanResultLocal, IShowHowToVideosPopup, IHideHowToVideosPopup } from './market-scan-results-actions';

export * from './admin-actions';
export * from './user';
export * from './policy';
export * from './invitation-actions';
export * from './adviser-actions';
export * from './operation-actions';
export * from './operation-policy-actions';
export * from './credit-card-actions';
export * from './policy-renewal-actions';
export * from './referencedata-actions';
export * from './notification-actions';
export * from './layout-actions';
export * from './provident-stripe-payment-actions';

export enum Types {
  SIGN_OUT = 'SIGN_OUT',
  GET_CONFIG_LOADED = 'GET_CONFIG_LOADED',
}

export interface IGetConfigLoaded extends Action {
  type: Types.GET_CONFIG_LOADED;
  data: IConfig;
}

export const GetConfigLoaded = (data: IConfig) => {
  return {
    type: Types.GET_CONFIG_LOADED,
    data,
  } as IGetConfigLoaded;
};

export const GetConfigAction = () => (dispatch: any) => {
  return getConfig().then((res) => {
    dispatch(GetConfigLoaded(res.data));
  });
};

export interface ISignOutAction extends Action {
  type: Types.SIGN_OUT;
}

export const SignOutAction = () => {
  return {
    type: Types.SIGN_OUT,
  } as ISignOutAction;
};

const initActions = [
  GetAllPolicyTypes,
  GetAllPolicyProvider,
  GetCreditCardBenefitsData,
  GetEmployers,
  GetWiki,
  GetPolicyScanReference,
  GetFormDefinitionReference,
];

export const InitApp = () => async (dispatch, getState) => {
  const { config }: IAppState = getState();
  if (!config) {
    await GetConfigAction()(dispatch);
  }

  initActions.forEach((func) => {
    func()(dispatch, getState);
  });
};

export type AppActionTypes =
  | IDeleteProviderPolicyTypeMappingLoaded
  | ISignOutAction
  | IGetCreditCardBenefitsDataLoaded
  | IGetAllPolicyProvidersLoaded
  | IGetAllPolicyTypesLoaded
  | ISelectPolicyProvider
  | IGetPolicyTypesByProviderLoaded
  | ICeatePolicyTypeLoaded
  | ICreateProviderPolicyMappingLoaded
  | ICreateProviderPolicyMappingLoading
  | IGetAllPolicySubTypesLoaded
  | IGetUserByIdLoaded
  | IGetUserByIdLoading
  | ICreatePolicyLoaded
  | ICreatePolicyFailed
  | IGetUserPoliciesLoading
  | IGetUserPoliciesLoaded
  | ICreatePolicySubTypeLoaded
  | ISelectPolicyType
  | IGetPolicySubTypeByPolicyTypeLoaded
  | ICreatePolicyTypeSubTypeMappingLoaded
  | IDeletePolicyTypeSubTypeMappingLoaded
  | IDeletePolicyLoaded
  | IUpdatePolicyProviderLoaded
  | IUpdatePolicyProviderLoading
  | IGetUsersLoaded
  | ISelectUser
  | IUpdatePolicyLoaded
  | IGetAttachmentForPolicyLoaded
  | IGetRenewalForPolicyLoaded
  | IAdminUpdatePolicyLoaded
  | IUpdateUserLoading
  | IUpdateUserLoaded
  | ICreateCreditCardPolicyLoaded
  | ICreateInvitationLoaded
  | IProcessInvitationLoaded
  | IDeleteInvitationLoaded
  | IGetInvitationsLoaded
  | IInvitationLoading
  | IShowCreateInvitationForm
  | ISetCurrentFamily
  | IInvitationFailed
  | IClearInvitationErrors
  | IAdminDeleteUserByIdLoaded
  | IAdminUpdateUserLoaded
  | IResetPolicyForm
  | ICreatePolicyLoading
  | ISelectPolicy
  | ICreateRenewalLoading
  | ICreateRenewalLoaded
  | ICreatePendingRenewal
  | IUpdateRenewalLoaded
  | IUpdatePendingRenewalLoaded
  | IGetPendingRenewalsLoaded
  | IResetRenewalSubmit
  | ISelectPolicyRenewalLoaded
  | IUpdateProviderPolicyMappingLoaded
  | ISelectPolicySubType
  | IUpdateSelectedPolicySubType
  | IGetConfigLoaded
  | IGetAllAdvisersLoaded
  | IGetAdviserConnectsLoaded
  | IGetAdviserConnectLoaded
  | ICreateAdviserConnectLoaded
  | IUpdateAdviserConnectLoaded
  | IOperationUpdateAdviserConnectPolicyScans
  | IOperationUpdateAdviserConnectStatus
  | IGetSharedInvitationsLoaded
  | IGetPolicyScanByPolicyIdLoaded
  | ICreatePolicyScanLoaded
  | IUpdateInvitationLoaded
  | IUpdatePolicyScanLoaded
  | IGetPendingPolicyScanLoaded
  | ILoading
  | ILoaded
  | IFailed
  | IPolicyScanLoaded
  | IPolicyScanLocalUpdated
  | IPolicyScansLoaded
  | IGetPolicyScanLoaded
  | IAdminGetUserLoaded
  | IAdminGetUserPolicies
  | IAdviserSubmitting
  | IAdviserConnectInfoUpdated
  | ICalendarLoading
  | ICalendlyEventCreated
  | ICreatePoliciesLoaded
  | IGetEmployersLoaded
  | IDeletePoliciesLoaded
  | IGetWikiLoaded
  | IPaymentLoading
  | IUpdateSelectedPolicyLocal
  | IUpdateSelectedPolicyRenewLocal
  | INewSelectedPolicyLocal
  | IAddPolicyModelOpen
  | IPaymentError
  | IPaymentSuccess
  | IGetCreditCardPoliciesLoaded
  | ICreateCreditCardPolicyLoaded
  | IDeleteCreditCardPolicyLoaded
  | ICreditCardSubmitting
  | ICreditCardResetForm
  | IUserBundlesLoaded
  | IGetPolicyBundlesLoaded
  | ICreatePolicyBundleLoaded
  | IDeletePolicyBundleLoaded
  | IUpdatePolicyLoading
  | IGetUserByIdFailed
  | ICreatePolicyScanLoading
  | ICreatePolicyScanFailed
  | ICreatePolicyScanWithoutPolicyLoaded
  | IGetPolicyScanReferenceLoaded
  | IFeedbackLoaded
  | IPolicyRenewalSubmitting
  | IPolicyRenewalFailed
  | IDeleteRenewalLoaded
  | IDeletePendingRenewalLoaded
  | IFilteredPoliciesLoaded
  | IFilteredPoliciesLoaded
  | IAdviserInquiryLoaded
  | IAdviserLoading
  | IAdviserFailed

  | IVerifyWindcavePaymentLoaded
  | IVerifyWindcavePaymentFailed
  | IAdminGetUserInvitationsLoaded
  | IAdminGetUserPolicyScansLoaded
  | IAdminGetUserSentInvitationsLoaded
  | IOperationGetAdviserConnectLoaded
  | IOperationGetSelectedAdviserConnectLoaded
  | IEmailNotificationLoaded
  | IOperationPolicyRenewalDetailsloaded
  | IOperationUpdatePolicyRenewal
  | IOperationGetMarketScanFeedbacks
  | INotificationsLoading
  | IGetNotificationsLoaded
  | IUpdateNotificationLoaded
  | ISeenNotificationsLoaded
  | IAdminLoading
  | IDeletePolicyNotificationsLoaded
  | IToggleAppBanner
  | IPolicyScanPayloadLoaded
  | IOperationGetAdviserConnectsForUserLoaded
  | IResetSubmitted
  | IGetRenewalsLoaded
  | IPaymentReset
  | IShowSessionExpiredModal
  | IToggleSidebar
  | ISetNavBarTitle
  | ISetUpdateMarketScanPopup
  | ISetPolicyDetailsSection
  | ISetPaymentStatus
  | ISetShowStripe
  | ISetStripeLoading
  | IDeletePolicyScanLoaded
  | IUpdateMarketScanResultLocal
  | IMarketScanResultLoaded
  | IShowHowToVideosPopup
  | IHideHowToVideosPopup;